import { render, staticRenderFns } from "./FieldSettings.vue?vue&type=template&id=a989c398&scoped=true&"
import script from "./FieldSettings.vue?vue&type=script&lang=js&"
export * from "./FieldSettings.vue?vue&type=script&lang=js&"
import style0 from "./FieldSettings.vue?vue&type=style&index=0&id=a989c398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a989c398",
  null
  
)

export default component.exports